import { parseLinks } from './linkify'
export interface ChatSpan { text: string; author?: boolean; bold?: boolean; href?: string }

/** Chat is plain text; existing URL detection does not interpret Markdown. */
export function plainChatSpans(content: string): ChatSpan[] {
  return parseLinks(content).map(segment => ({ text: segment.value, ...(segment.type === 'link' ? { href: segment.href } : {}) }))
}
